const obj = {
  gutterBottom: {
    marginBottom: 8
  }
};

export default obj;
